import { connect } from 'react-redux'
import { getFormSyncErrors } from 'redux-form'

const withSyncFormErrors = (formName) =>
  connect((state) => ({
    syncErrors: getFormSyncErrors(formName)(state),
  }))

export default withSyncFormErrors
